import React from "react";
import Hero from "../components/sections/Hero";
import RoseExperience from "../components/sections/RoseExperience";
import NewVarieties from "../components/sections/NewVarieties";
import SeasonPicks from "../components/sections/SeasonPicks";
import ExploreFlowers from "../components/sections/ExploreFlowers";
import Markets from "../components/sections/Markets";
import AboutTimeline from "../components/sections/AboutTimeline";
import CorporateNumbers from "../components/sections/CorporateNumbers";
import QualityJourney from "../components/sections/QualityJourney";
import Certifications from "../components/sections/Certifications";
import FloralNews from "../components/sections/FloralNews";
import InstagramFeed from "../components/sections/InstagramFeed";
import PartnershipForm from "../components/sections/PartnershipForm";
import PromoPopup from "../components/common/PromoPopup";
import Footer from "../components/layout/Footer";

export default function HomePage() {
  return (
    <main>
      <Hero />
      <RoseExperience />
      <NewVarieties />
      <SeasonPicks />
      <ExploreFlowers />
      <Markets />
      <AboutTimeline />
      <CorporateNumbers />
      <QualityJourney />
      <Certifications />
      <FloralNews />
      <InstagramFeed />
      <PartnershipForm />
      <Footer />
      <PromoPopup />
    </main>
  );
}
